<script>
import Endpoints from '../../../../components/common/Endpoints';
import Common from '../../../../components/common/Common';
import Request from '../../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: async(payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');

    },
    methods:{
      filter: async function(){
        let responseParts = (await Request.do(this, 'POST', Request.getDefaultHeader(this), 
        {fileName: "Companies",collectionName: "companies",filters:{status:"ACTIVE",typeService: "PART_SUPPLIER"}}, `${Endpoints.systemUsers.count}`)).data;
        let responseService = (await Request.do(this, 'POST', Request.getDefaultHeader(this), 
        {fileName: "Companies",collectionName: "companies",filters:{status:"ACTIVE",typeService: "SERVICE_PROVIDER"}}, `${Endpoints.systemUsers.count}`)).data;
        let responseCertifier = (await Request.do(this, 'POST', Request.getDefaultHeader(this), 
        {fileName: "Companies",collectionName: "companies",filters:{status:"ACTIVE",typeService: "CERTIFIER"}}, `${Endpoints.systemUsers.count}`)).data;
        let responseFleetDriver = (await Request.do(this, 'POST', Request.getDefaultHeader(this), 
        {fileName: "Companies",collectionName: "companies",filters:{status:"ACTIVE",typeService: "FLEET_DRIVER"}}, `${Endpoints.systemUsers.count}`)).data;
 
        this.total = responseParts.count + responseService.count + responseCertifier.count + responseFleetDriver.count;

        if (responseParts.status==200 && responseService.status==200 && responseCertifier.status ==200 && responseFleetDriver.status==200){
            this.chart.data.datasets[0].data = [responseParts.count,responseService.count,responseCertifier.count,responseFleetDriver.count];
            this.chart.update();
        }
      } 
    }
}
</script>
